import { Controller } from "@hotwired/stimulus"

/**
 * Toggle controller for showing/hiding content based on checkbox state.
 *
 * Usage:
 *   <div data-controller="toggle">
 *     <input type="checkbox" data-toggle-target="trigger" data-action="change->toggle#toggle">
 *     <div data-toggle-target="content" class="hidden">
 *       Content to show/hide
 *     </div>
 *   </div>
 *
 * The content will be shown when the checkbox is checked, hidden when unchecked.
 * Initial state is determined by the checkbox's checked state on connect.
 */
export default class extends Controller {
  static targets = ["trigger", "content"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isChecked = this.triggerTarget.checked

    this.contentTargets.forEach((content) => {
      if (isChecked) {
        content.classList.remove("hidden")
      } else {
        content.classList.add("hidden")
      }
    })
  }
}
